import { theme, ThemeConfig } from "antd";

export const PRIMARY_COLOR = import.meta.env.VITE_THEME_PRIMARY_COLOR;
export const DEFAULT_THEME_MODE = import.meta.env.VITE_DEFAULT_THEME_MODE;
export const DARK_MODE_BG_COLOR = "#001529";
export const LIGHT_MODE_BG_COLOR = "#fff";

type ThemeData = {
	borderRadius: number;
	colorPrimary: string;
};

// Preset algorithms
const { defaultAlgorithm, darkAlgorithm } = theme;

// Theme data configuration
const themeData: ThemeData = {
	borderRadius: 6,
	colorPrimary: PRIMARY_COLOR
};

const prefersDarkMode = window.matchMedia && window.matchMedia("(prefers-color-scheme: dark)").matches;
const enableSystemTheme = import.meta.env.VITE_ENABLE_SYSTEM_THEME === "true";
export const useDarkMode = prefersDarkMode && enableSystemTheme;

const currentAlgorithm = useDarkMode ? darkAlgorithm : defaultAlgorithm;

const appTheme: ThemeConfig = {
	algorithm: [currentAlgorithm],
	token: {
		colorPrimary: themeData.colorPrimary,
		borderRadius: themeData.borderRadius,
		colorTextDisabled: useDarkMode ? "#4d4d4d" : "rgba(0, 0, 0, 0.42)"
	},
	components: {
		Layout: {
			headerBg: useDarkMode ? DARK_MODE_BG_COLOR : LIGHT_MODE_BG_COLOR
		}
	}
};

export default appTheme;
